import React from "react";

type TabLabelProps = {
  children: React.JSX.Element | React.JSX.Element[] | React.ReactNode;
};

export function TabLabel({ children }: TabLabelProps) {
  return (
    <div className="TabLabel h-3 text-[10px] font-bold">
      <div className="TabLabel_Item text-xs font-medium">{children}</div>
    </div>
  );
}
